// area selection
let startX, startY, endX, endY
let selectionRectangle = null

// //context menu
let events = ['contextmenu', 'touchstart']
var timeout
var lastTap = 0
let contextMenu = document.getElementById('context-menu')

// Двойной клик

let lastClickTime = 0
let doubleClickDelay = 300 // Время задержки для определения двойного щелчка (в миллисекундах)

// area blocks
const blockFolder = document.querySelector('.block-folder')
const blockTable = document.querySelector('.block-table')
const blockDoc = document.querySelector('.block-doc')
const blockSlides = document.querySelector('.block-slides')
const blockInfo = document.querySelector('.block-info')
const blockDonate = document.querySelector('.block-donate')

// FullScreenWindowBrowser
let btnClickFull = document.querySelector('.btnClickFull')

//rain
let canvas1 = document.getElementById('canvas1')
let canvas2 = document.getElementById('canvas2')
let canvas3 = document.getElementById('canvas3')
let ctx1 = canvas1.getContext('2d')
let ctx2 = canvas2.getContext('2d')
let ctx3 = canvas3.getContext('2d')

let rainthroughnum = 150
let speedRainTrough = 15
let RainTrough = []

let rainnum = 150
let rain = []

let lightning = []
let lightTimeCurrent = 0
let lightTimeTotal = 0

let w = (canvas1.width = canvas2.width = canvas3.width = window.innerWidth)
let h = (canvas1.height = canvas2.height = canvas3.height = window.innerHeight)

//play sound rain
let idAudioSound = document.getElementById('rain-sound')

//lockscreen
let timerId
let classBackgrounds = document.querySelector('.area-selection')
let classLockSreen = document.querySelector('.lockscreen')
let classInputValid = document.querySelector('.lockscreen__password')
let addClassDisplayNone = 'noactive-lockscreen'
let addClassWrongPassword = 'wrong-password'
let password = document.querySelector('#password')
let btnCheck = document.querySelector('#check')
let classActivePC = document.querySelector('.pcactive')
let addClassActivePC = 'activeBG'

//window
// window main
let classWindowMove = document.querySelector('.window-move')
let addClassWindowZIndex = 'window-active-z-index'
let classWindowZIndex = document.querySelector('window-active-z-index')
const transitionCubicBezier1 = '0.09s cubic-bezier(0.455, 0.03, 0.515, 0.955)'

//window active settings
// add class window active
let addClassWindowActive = 'window-active'
let addClassWindowFold = 'window-fold'
let addClassWindowExpand = 'window-expand'

//window active when using the buttons
// add class buttons navigation active (window)
let addClassBtnNavActive = 'btn-nav-active'
let addClassBtnNavFocus = 'btn-nav-focus'
let addClassBtnNavNoneFocus = 'btn-nav-none-focus'
let addClassBtnNavPressed = 'btn-nav-pressed'
let addClassBtnNavPressedNone = 'btn-nav-pressed-none'

//add class button weather active
let addClassBtnWeatherActive = 'btn-weather-active'

// class buttons navigation
let btnFolder = document.querySelector('.btn-folder')
let btnFolderDesktop = document.querySelector('.btn-folder-desktop')
let btnBrowser = document.querySelector('.btn-browser')
let btnBrowserApps = document.querySelector('.btn-browser-apps')
let btnCmd = document.querySelector('.btn-cmd')
let btnCmdApps = document.querySelector('.btn-cmd-apps')
let btnCalculator = document.querySelector('.btn-calculator')
let btnCalculatorApps = document.querySelector('.btn-calculator-apps')
let btnNotepad = document.querySelector('.btn-notepad')
let btnNotepadApps = document.querySelector('.btn-notepad-apps')
let btnInfo = document.querySelector('.btn-info')
let btnInfoDesktop = document.querySelector('.btn-info-desktop')
let btnInfoApps = document.querySelector('.btn-info-apps')
let btnWeather = document.querySelector('.btn-weather')
let btnWeatherDesktop = document.querySelector('.btn-weather-desktop')

// class window
let classWindowFolder = document.querySelector('.window-folder')
let classWindowBrowser = document.querySelector('.window-browser')
let classWindowCmd = document.querySelector('.window-cmd')
let classWindowCalculator = document.querySelector('.window-calculator')
let classWindowNotepad = document.querySelector('.window-notepad')
let classWindowInfo = document.querySelector('.window-info')
let classWindowWeather = document.querySelector('.window-weather')

// class window top panel
let classWindowFolderTop = document.querySelector('.window-folder-top')
let classWindowBrowserTop = document.querySelector('.window-browser-top')
let classWindowCmdTop = document.querySelector('.window-cmd-top')
let classWindowCalculatorTop = document.querySelector('.window-calculator-top')
let classWindowNotepadTop = document.querySelector('.window-notepad-top')
let classWindowInfoTop = document.querySelector('.window-info-top')
let classWindowWeatherTop = document.querySelector('.window-weather-top')

// class window navigation buttons
//fold
let classBtnWindowFolderFold = document.querySelector('.btn-window-folder-fold')
let classBtnWindowBrowserFold = document.querySelector(
    '.btn-window-browser-fold'
)
let classBtnWindowCmdFold = document.querySelector('.btn-window-cmd-fold')
let classBtnWindowCalculatorFold = document.querySelector(
    '.btn-window-calculator-fold'
)
let classBtnWindowNotepadFold = document.querySelector(
    '.btn-window-notepad-fold'
)
let classBtnWindowInfoFold = document.querySelector('.btn-window-info-fold')

//expand
let classBtnWindowFolderExpand = document.querySelector(
    '.btn-window-folder-expand'
)
let classBtnWindowBrowserExpand = document.querySelector(
    '.btn-window-browser-expand'
)
let classBtnWindowCmdExpand = document.querySelector('.btn-window-cmd-expand')
let classBtnWindowCalculatorExpand = document.querySelector(
    '.btn-window-calculator-expand'
)
let classBtnWindowNotepadExpand = document.querySelector(
    '.btn-window-notepad-expand'
)
let classBtnWindowInfoExpand = document.querySelector('.btn-window-info-expand')
let classBtnWindowWeatherExpand = document.querySelector(
    '.btn-window-weather-expand'
)

//close
let classBtnWindowFolderClose = document.querySelector(
    '.btn-window-folder-close'
)
let classBtnWindowBrowserClose = document.querySelector(
    '.btn-window-browser-close'
)
let classBtnWindowCmdClose = document.querySelector('.btn-window-cmd-close')
let classBtnWindowCalculatorClose = document.querySelector(
    '.btn-window-calculator-close'
)
let classBtnWindowNotepadClose = document.querySelector(
    '.btn-window-notepad-close'
)
let classBtnWindowInfoClose = document.querySelector('.btn-window-info-close')
let classBtnWindowWeatherClose = document.querySelector(
    '.btn-window-weather-close'
)

// class window expand svg icons
//svg active expand
let classWindowFolderIconSvgExpand = document.querySelector(
    '.window-folder-icon-svg-expand'
)
let classWindowBrowserIconSvgExpand = document.querySelector(
    '.window-browser-icon-svg-expand'
)
let classWindowCmdIconSvgExpand = document.querySelector(
    '.window-cmd-icon-svg-expand'
)
let classWindowCalculatorIconSvgExpand = document.querySelector(
    '.window-calculator-icon-svg-expand'
)
let classWindowNotepadIconSvgExpand = document.querySelector(
    '.window-notepad-icon-svg-expand'
)
let classWindowInfoIconSvgExpand = document.querySelector(
    '.window-info-icon-svg-expand'
)
let classWindowWeatherIconSvgExpand = document.querySelector(
    '.window-weather-icon-svg-expand'
)

//svg none active expand
let classWindowFolderIconSvgExpandNone = document.querySelector(
    '.window-folder-icon-svg-expand-none'
)
let classWindowBrowserIconSvgExpandNone = document.querySelector(
    '.window-browser-icon-svg-expand-none'
)
let classWindowCmdIconSvgExpandNone = document.querySelector(
    '.window-cmd-icon-svg-expand-none'
)
let classWindowCalculatorIconSvgExpandNone = document.querySelector(
    '.window-calculator-icon-svg-expand-none'
)
let classWindowNotepadIconSvgExpandNone = document.querySelector(
    '.window-notepad-icon-svg-expand-none'
)
let classWindowInfoIconSvgExpandNone = document.querySelector(
    '.window-info-icon-svg-expand-none'
)
let classWindowWeatherIconSvgExpandNone = document.querySelector(
    '.window-weather-icon-svg-expand-none'
)

// window calculator history variables
let classCalculatorHistory = document.querySelector(
    '.window-calculator-history'
)
let btnCloseCalculator = document.querySelector('.window-calculator-line-btn')
let addClassCActiveClose = 'activecalcbtnclose'
let addClassActiveCalcCloseHistory = 'active-calc-close-history'
let addClassActiveWidthWindowCalculator = 'active-width-wcalculator'

//navigation
// fold btn
let classNavFoldCollapsAll = document.querySelector('.navigation-options__fold')

// check fold
let addCheckActiveFold = 'check-active-btn'
let checkActiveFold = document.querySelector('.check-active-btn')

//Apps
let classApps = document.querySelector('.apps')
let addClassActiveApps = 'active-apps'
let btnApps = document.querySelector('.apps-btn')

//wifiBtn
let classBtnSvgWifi = document.querySelector('.svg-wifi')
let classBtnSvgWifiOff = document.querySelector('.svg-wifi-off')
let addClassActiveBtnSvgWifi = 'btn-active-svg-wifi'
let addClassNoneActiveBtnSvgWifi = 'btn-none-active-svg-wifi'

let classBtnSvgWifi2 = document.querySelector('.svg-wifi2')
let classBtnSvgWifiOff2 = document.querySelector('.svg-wifi-off2')
let addClassActiveBtnSvgWifi2 = 'btn-active-svg-wifi'
let addClassNoneActiveBtnSvgWifi2 = 'btn-none-active-svg-wifi'

//modalWifi
let classWifi = document.querySelector('.modal-nav-wifi')
let addClassActiveModal = 'modal-active'
let btnWifi = document.querySelector('.wifi-btn')
let btnCheckboxWifi = document.querySelector('#checkbox-wifi-btn')
let classItemsWifi = document.querySelector('#modal-nav-wifi')
let addClasToggleWifiItems = 'active-wifi-items'

//navigation
let classWifi2 = document.querySelector('.modal-nav-wifi2')
let btnMusic = document.querySelector('.music-btn')
let btnWifi2 = document.querySelector('.wifi-btn2')
let btnNavigation = document.querySelector('.navigation__items')
let addClassActiveBtn = 'navigation-active-btn'
let classNavigation = document.querySelector('.navigation')
let classNavigationInfo = document.querySelector('.navigation-info')
let classNavigationInfoItems = document.querySelector('.navigation-info__item')
let classNavigationOption = document.querySelector('.navigation-options')
let classNavigationOptionInner = document.querySelector(
    '.navigation-options__inner'
)
let classNavigationOptionItems = document.querySelector(
    '.navigation-options__items'
)
let btnCheckboxWifi2 = document.querySelector('#checkbox-wifi-btn2')
let classItemsWifi2 = document.querySelector('#modal-nav-wifi2')
let classAddNavigationOptions = document.querySelector(
    '.navigation-options__add-item'
)
let addClassActiveNavigationOptionScaleWidth =
    'active-navigation-option-scale-width'

// add file context menu create
let btnAddTable = document.querySelector('.btn-create-table')
let btnAddDoc = document.querySelector('.btn-create-doc')
let btnAddSlides = document.querySelector('.btn-create-slides')
let classFileTable = document.querySelector('.block-table')
let classFileDoc = document.querySelector('.block-doc')
let bclassFileSlides = document.querySelector('.block-slides')
let addClassActiveFile = 'active-file-create'

//modalBattery
let btnBattery = document.querySelector('.battery-btn')
let classActiveModalBattery = document.querySelector('.modal-battery')
let addClassActiveModalBattery = 'battery-modal-active'

//modal volume
let classModalVolume = document.querySelector('.modal-modifi-pos')
let classModalVolume2 = document.querySelector('.modal-modifi-pos2')
let btnVolume = document.querySelector('.volume-btn')
let btnVolume2 = document.querySelector('.volume-btn2')

//modaMusic
let classMusicModal = document.querySelector('.music')
let addClassActiveModalMusic = 'music-active'
let classMusicInner = document.querySelector('.music__inner')
let addClassVisibleNone = 'music-item-none'

//musicPlaylist
let btnMusicPlaylist = document.querySelector('.btn-music-playlist')
let classModalMusicPlaylist = document.querySelector('.music-playlist__inner')
let addClassActiveMusicPlaylist = 'music-playlist-active'
let btnMusicPlaylistItem = document.querySelector('.music-playlist__nav-item')

let slider = document.getElementById('slider')
let slider2 = document.getElementById('slider2')
let slider3 = document.getElementById('slider3')
let slider4 = document.getElementById('slider4')

// Window - перемещение окон
let windowMoveFolder = document.querySelector('.window-folder')
let windowMoveCMD = document.querySelector('.window-cmd')
let windowMoveBrowser = document.querySelector('.window-browser')
let windowMoveCalculator = document.querySelector('.window-calculator')
let windowMoveWeather = document.querySelector('.window-weather')
let windowMoveNotepad = document.querySelector('.window-notepad')
let windowMoveInfo = document.querySelector('.window-info')

// Swiper Slider Apps
const swiperSliderAppsClass = '.apps-slider'

getSwiperApps()

function getSwiperApps() {
    new Swiper(swiperSliderAppsClass, {
        // looping slider
        // loop: true,

        mousewheel: true,

        // key control
        keyboard: {
            enable: true,
            onlyInViewport: true,
            pageUpDown: true,
        },

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    })
}

getWindowMoveFolder()

function getWindowMoveFolder() {
    // Initialize the position variables
    let pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0

    // Attach the drag events to the header div
    windowMoveFolder.querySelector('.window-folder-top').onmousedown =
        dragMouseDown

    function dragMouseDown(e) {
        e = e || window.event
        e.preventDefault()
        // Get the mouse cursor position at startup
        pos3 = e.clientX
        pos4 = e.clientY
        document.onmouseup = closeDragElement
        // Call a function whenever the cursor moves
        document.onmousemove = elementDrag
    }

    function elementDrag(e) {
        e = e || window.event
        e.preventDefault()
        // Calculate the new cursor position
        pos1 = pos3 - e.clientX
        pos2 = pos4 - e.clientY
        pos3 = e.clientX
        pos4 = e.clientY
        // Set the element's new position
        windowMoveFolder.style.top = windowMoveFolder.offsetTop - pos2 + 'px'
        windowMoveFolder.style.left = windowMoveFolder.offsetLeft - pos1 + 'px'
        windowMoveFolder.style.transition = 'none'
    }

    function closeDragElement() {
        // Stop moving when mouse button is released
        document.onmouseup = null
        document.onmousemove = null
        windowMoveFolder.style.transition = transitionCubicBezier1
    }
}

getWindowMoveCMD()

function getWindowMoveCMD() {
    // Initialize the position variables
    let pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0

    // Attach the drag events to the header div
    windowMoveCMD.querySelector('.window-cmd-top').onmousedown = dragMouseDown

    function dragMouseDown(e) {
        e = e || window.event
        e.preventDefault()
        // Get the mouse cursor position at startup
        pos3 = e.clientX
        pos4 = e.clientY
        document.onmouseup = closeDragElement
        // Call a function whenever the cursor moves
        document.onmousemove = elementDrag
    }

    function elementDrag(e) {
        e = e || window.event
        e.preventDefault()
        // Calculate the new cursor position
        pos1 = pos3 - e.clientX
        pos2 = pos4 - e.clientY
        pos3 = e.clientX
        pos4 = e.clientY
        // Set the element's new position
        windowMoveCMD.style.top = windowMoveCMD.offsetTop - pos2 + 'px'
        windowMoveCMD.style.left = windowMoveCMD.offsetLeft - pos1 + 'px'
        windowMoveCMD.style.transition = 'none'
    }

    function closeDragElement() {
        // Stop moving when mouse button is released
        document.onmouseup = null
        document.onmousemove = null
        windowMoveCMD.style.transition = transitionCubicBezier1
    }
}

getWindowMoveBrowser()

function getWindowMoveBrowser() {
    // Initialize the position variables
    let pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0

    // Attach the drag events to the header div
    windowMoveBrowser.querySelector('.window-browser-top').onmousedown =
        dragMouseDown

    function dragMouseDown(e) {
        e = e || window.event
        e.preventDefault()
        // Get the mouse cursor position at startup
        pos3 = e.clientX
        pos4 = e.clientY
        document.onmouseup = closeDragElement
        // Call a function whenever the cursor moves
        document.onmousemove = elementDrag
    }

    function elementDrag(e) {
        e = e || window.event
        e.preventDefault()
        // Calculate the new cursor position
        pos1 = pos3 - e.clientX
        pos2 = pos4 - e.clientY
        pos3 = e.clientX
        pos4 = e.clientY
        // Set the element's new position
        windowMoveBrowser.style.top = windowMoveBrowser.offsetTop - pos2 + 'px'
        windowMoveBrowser.style.left =
            windowMoveBrowser.offsetLeft - pos1 + 'px'
        windowMoveBrowser.style.transition = 'none'
    }

    function closeDragElement() {
        // Stop moving when mouse button is released
        document.onmouseup = null
        document.onmousemove = null
        windowMoveBrowser.style.transition = transitionCubicBezier1
    }
}

getWindowMoveCalculator()

function getWindowMoveCalculator() {
    // Initialize the position variables
    let pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0

    // Attach the drag events to the header div
    windowMoveCalculator.querySelector('.window-calculator-top').onmousedown =
        dragMouseDown

    function dragMouseDown(e) {
        e = e || window.event
        e.preventDefault()
        // Get the mouse cursor position at startup
        pos3 = e.clientX
        pos4 = e.clientY
        document.onmouseup = closeDragElement
        // Call a function whenever the cursor moves
        document.onmousemove = elementDrag
    }

    function elementDrag(e) {
        e = e || window.event
        e.preventDefault()
        // Calculate the new cursor position
        pos1 = pos3 - e.clientX
        pos2 = pos4 - e.clientY
        pos3 = e.clientX
        pos4 = e.clientY
        // Set the element's new position
        windowMoveCalculator.style.top =
            windowMoveCalculator.offsetTop - pos2 + 'px'
        windowMoveCalculator.style.left =
            windowMoveCalculator.offsetLeft - pos1 + 'px'
        windowMoveCalculator.style.transition = 'none'
    }

    function closeDragElement() {
        // Stop moving when mouse button is released
        document.onmouseup = null
        document.onmousemove = null
        windowMoveCalculator.style.transition = transitionCubicBezier1
    }
}

getWindowMoveWeather()

function getWindowMoveWeather() {
    // Initialize the position variables
    let pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0

    // Attach the drag events to the header div
    windowMoveWeather.querySelector('.window-weather-top').onmousedown =
        dragMouseDown

    function dragMouseDown(e) {
        e = e || window.event
        e.preventDefault()
        // Get the mouse cursor position at startup
        pos3 = e.clientX
        pos4 = e.clientY
        document.onmouseup = closeDragElement
        // Call a function whenever the cursor moves
        document.onmousemove = elementDrag
    }

    function elementDrag(e) {
        e = e || window.event
        e.preventDefault()
        // Calculate the new cursor position
        pos1 = pos3 - e.clientX
        pos2 = pos4 - e.clientY
        pos3 = e.clientX
        pos4 = e.clientY
        // Set the element's new position
        windowMoveWeather.style.top = windowMoveWeather.offsetTop - pos2 + 'px'
        windowMoveWeather.style.left =
            windowMoveWeather.offsetLeft - pos1 + 'px'
        windowMoveWeather.style.transition = 'none'
    }

    function closeDragElement() {
        // Stop moving when mouse button is released
        document.onmouseup = null
        document.onmousemove = null
        windowMoveWeather.style.transition = transitionCubicBezier1
    }
}

getWindowMoveNotepad()

function getWindowMoveNotepad() {
    // Initialize the position variables
    let pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0

    // Attach the drag events to the header div
    windowMoveNotepad.querySelector('.window-notepad-top').onmousedown =
        dragMouseDown

    function dragMouseDown(e) {
        e = e || window.event
        e.preventDefault()
        // Get the mouse cursor position at startup
        pos3 = e.clientX
        pos4 = e.clientY
        document.onmouseup = closeDragElement
        // Call a function whenever the cursor moves
        document.onmousemove = elementDrag
    }

    function elementDrag(e) {
        e = e || window.event
        e.preventDefault()
        // Calculate the new cursor position
        pos1 = pos3 - e.clientX
        pos2 = pos4 - e.clientY
        pos3 = e.clientX
        pos4 = e.clientY
        // Set the element's new position
        windowMoveNotepad.style.top = windowMoveNotepad.offsetTop - pos2 + 'px'
        windowMoveNotepad.style.left =
            windowMoveNotepad.offsetLeft - pos1 + 'px'
        windowMoveNotepad.style.transition = 'none'
    }

    function closeDragElement() {
        // Stop moving when mouse button is released
        document.onmouseup = null
        document.onmousemove = null
        windowMoveNotepad.style.transition = transitionCubicBezier1
    }
}

getWindowMoveInfo()

function getWindowMoveInfo() {
    // Initialize the position variables
    let pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0

    // Attach the drag events to the header div
    windowMoveInfo.querySelector('.window-info-top').onmousedown = dragMouseDown

    function dragMouseDown(e) {
        e = e || window.event
        e.preventDefault()
        // Get the mouse cursor position at startup
        pos3 = e.clientX
        pos4 = e.clientY
        document.onmouseup = closeDragElement
        // Call a function whenever the cursor moves
        document.onmousemove = elementDrag
    }

    function elementDrag(e) {
        e = e || window.event
        e.preventDefault()
        // Calculate the new cursor position
        pos1 = pos3 - e.clientX
        pos2 = pos4 - e.clientY
        pos3 = e.clientX
        pos4 = e.clientY
        // Set the element's new position
        windowMoveInfo.style.top = windowMoveInfo.offsetTop - pos2 + 'px'
        windowMoveInfo.style.left = windowMoveInfo.offsetLeft - pos1 + 'px'
        windowMoveInfo.style.transition = 'none'
    }

    function closeDragElement() {
        // Stop moving when mouse button is released
        document.onmouseup = null
        document.onmousemove = null
        windowMoveInfo.style.transition = transitionCubicBezier1
    }
}

getContextMenu()

function getContextMenu() {
    events.forEach((eventType) => {
        document.addEventListener(
            eventType,
            (e) => {
                e.preventDefault()

                let mouseX = e.clientX || e.touches[0].clientX
                let mouseY = e.clientY || e.touches[0].clientY

                let menuHeight = contextMenu.getBoundingClientRect().height
                let menuWidth = contextMenu.getBoundingClientRect().width

                let width = window.innerWidth
                let height = window.innerHeight

                if (width - mouseX <= 200) {
                    contextMenu.style.left = width - menuWidth + 'px'
                    contextMenu.style.top = mouseY + 'px'

                    if (height - mouseY <= 200) {
                        contextMenu.style.top = mouseY - menuHeight + 'px'
                    }
                } else {
                    contextMenu.style.left = mouseX + 'px'
                    contextMenu.style.top = mouseY + 'px'

                    if (height - mouseY <= 200) {
                        contextMenu.style.top = mouseY - menuHeight + 'px'
                    }
                }

                contextMenu.style.visibility = 'visible'
            },
            {
                passive: false,
            }
        )
    })

    document.addEventListener('touchend', function (e) {
        var currentTime = new Date().getTime()
        var tapLength = currentTime - lastTap

        clearTimeout(timeout)

        if (tapLength < 500 && tapLength > 0) {
            contextMenu.style.visibility = 'hidden'
            e.preventDefault()
        } else {
            timeout = setTimeout(function () {
                clearTimeout(timeout)
            }, 500)
        }
        lastTap = currentTime
    })

    document.addEventListener('click', function (e) {
        if (!contextMenu.contains(e.target)) {
            contextMenu.style.visibility = 'hidden'
        }
    })
}

getTimeDate()

function getTimeDate() {
    //time - date
    function zero_first_format(value) {
        if (value < 10) {
            value = '0' + value
        }
        return value
    }

    function time() {
        var current_datetime = new Date()
        var hours = zero_first_format(current_datetime.getHours())
        var minutes = zero_first_format(current_datetime.getMinutes())

        return hours + ':' + minutes
    }

    setInterval(function () {
        document.getElementById('time').innerHTML = time()
        document.getElementById('time-2').innerHTML = time()
        document.getElementById('time-3').innerHTML = time()
    }, 1000)

    function date() {
        var current_datetime = new Date()
        var day = zero_first_format(current_datetime.getDate())
        var month = zero_first_format(current_datetime.getMonth() + 1)
        var year = current_datetime.getFullYear()

        return day + '.' + month + '.' + year
    }

    setInterval(function () {
        document.getElementById('date').innerHTML = date()
        document.getElementById('date-2').innerHTML = date()
        document.getElementById('date-3').innerHTML = date()
    }, 1000)
}

getLockScreen()

function getLockScreen() {
    function getSubmitPasswordCheck() {
        if (password.value == 'admin6&33') {
            classLockSreen.classList.add(addClassDisplayNone)
            classActivePC.style.opacity = '1'
        } else {
            classInputValid.classList.add(addClassWrongPassword)
        }
    }

    btnCheck.addEventListener('click', function () {
        getSubmitPasswordCheck()
    })

    document.addEventListener('keydown', function (enter) {
        if (enter.keyCode == 13) {
            getSubmitPasswordCheck()
        }
    })

    timerId = setTimeout(function tick() {
        classInputValid.classList.remove(addClassWrongPassword)

        let checkLockscreen = document.querySelector('.noactive-lockscreen')
        if (checkLockscreen) {
            document.querySelector('#remove').innerHTML = ''
        }
        timerId = setTimeout(tick, 1000)
    }, 1000)
}

getWindowFolder()

function getWindowFolder() {
    // button navigation
    function getActiveNavBtn() {
        btnFolder.classList.remove(addClassBtnNavPressedNone)
        btnFolder.classList.add(addClassBtnNavFocus)
        btnFolder.classList.add(addClassBtnNavActive)
        classWindowFolder.classList.add(addClassWindowActive)
    }

    // btn navigation
    btnFolder.addEventListener('click', function () {
        getActiveNavBtn()

        if (classWindowFolder.classList.contains(addClassWindowFold)) {
            btnFolder.classList.add(addClassBtnNavFocus)
            btnFolder.classList.remove(addClassBtnNavNoneFocus)
            classWindowFolder.classList.remove(addClassWindowFold)
        }
    })

    // btn desktop
    btnFolderDesktop.addEventListener('click', function (event) {
        let currentTime = new Date().getTime()

        // Проверяем, прошло ли достаточно времени для определения двойного щелчка
        if (currentTime - lastClickTime < doubleClickDelay) {
            getActiveNavBtn()
        }

        lastClickTime = currentTime
    })

    // Fold button
    function getWindowActiveFold() {
        btnFolder.classList.add(addClassBtnNavNoneFocus)
        classWindowFolder.classList.remove(addClassWindowActive)
        classWindowFolder.classList.toggle(addClassWindowFold)
    }

    classBtnWindowFolderFold.addEventListener('click', function () {
        getWindowActiveFold()
    })

    // Expand button
    function getWindowActiveExpand() {
        classWindowFolder.classList.toggle(addClassWindowExpand)

        if (classWindowFolder.classList.contains(addClassWindowExpand)) {
            classWindowFolderIconSvgExpand.style.display = 'none'
            classWindowFolderIconSvgExpandNone.style.display = 'block'
        }

        if (!classWindowFolder.classList.contains(addClassWindowExpand)) {
            classWindowFolderIconSvgExpand.style.display = 'block'
            classWindowFolderIconSvgExpandNone.style.display = 'none'
        }
    }

    classBtnWindowFolderExpand.addEventListener('click', function () {
        getWindowActiveExpand()
    })

    // Double click window panel top
    classWindowFolderTop.addEventListener('click', function (event) {
        let currentTime = new Date().getTime()

        // Проверяем, прошло ли достаточно времени для определения двойного щелчка
        if (currentTime - lastClickTime < doubleClickDelay) {
            getWindowActiveExpand()
        }

        lastClickTime = currentTime
    })

    // Close button
    function getWindowActiveClose() {
        btnFolder.classList.remove(addClassBtnNavFocus)
        btnFolder.classList.remove(addClassBtnNavActive)
        btnFolder.classList.remove(addClassBtnNavNoneFocus)
        classWindowFolder.classList.remove(addClassWindowActive)

        btnFolder.classList.add(addClassBtnNavPressedNone)
    }

    classBtnWindowFolderClose.addEventListener('click', function () {
        getWindowActiveClose()
    })
}

getWindowBrowser()

function getWindowBrowser() {
    // button navigation
    function getActiveNavBtn() {
        btnBrowser.classList.remove(addClassBtnNavPressedNone)
        btnBrowser.classList.add(addClassBtnNavFocus)
        btnBrowser.classList.add(addClassBtnNavActive)
        classWindowBrowser.classList.add(addClassWindowActive)
    }

    // btn navigation
    btnBrowser.addEventListener('click', function () {
        getActiveNavBtn()

        if (classWindowBrowser.classList.contains(addClassWindowFold)) {
            btnBrowser.classList.add(addClassBtnNavFocus)
            btnBrowser.classList.remove(addClassBtnNavNoneFocus)
            classWindowBrowser.classList.remove(addClassWindowFold)
        }
    })

    // btn apps
    btnBrowserApps.addEventListener('click', function () {
        getActiveNavBtn()
    })

    // Fold button
    function getWindowActiveFold() {
        btnBrowser.classList.add(addClassBtnNavNoneFocus)
        classWindowBrowser.classList.remove(addClassWindowActive)
        classWindowBrowser.classList.toggle(addClassWindowFold)
    }

    classBtnWindowBrowserFold.addEventListener('click', function () {
        getWindowActiveFold()
    })

    // Expand button
    function getWindowActiveExpand() {
        classWindowBrowser.classList.toggle(addClassWindowExpand)

        if (classWindowBrowser.classList.contains(addClassWindowExpand)) {
            classWindowBrowserIconSvgExpand.style.display = 'none'
            classWindowBrowserIconSvgExpandNone.style.display = 'block'
        }

        if (!classWindowBrowser.classList.contains(addClassWindowExpand)) {
            classWindowBrowserIconSvgExpand.style.display = 'block'
            classWindowBrowserIconSvgExpandNone.style.display = 'none'
        }
    }

    classBtnWindowBrowserExpand.addEventListener('click', function () {
        getWindowActiveExpand()
    })

    // Double click window panel top
    classWindowBrowserTop.addEventListener('click', function (event) {
        let currentTime = new Date().getTime()

        // Проверяем, прошло ли достаточно времени для определения двойного щелчка
        if (currentTime - lastClickTime < doubleClickDelay) {
            getWindowActiveExpand()
        }

        lastClickTime = currentTime
    })

    // Close button
    function getWindowActiveClose() {
        btnBrowser.classList.remove(addClassBtnNavFocus)
        btnBrowser.classList.remove(addClassBtnNavActive)
        btnBrowser.classList.remove(addClassBtnNavNoneFocus)
        classWindowBrowser.classList.remove(addClassWindowActive)
        
        btnBrowser.classList.add(addClassBtnNavPressedNone)
    }

    classBtnWindowBrowserClose.addEventListener('click', function () {
        getWindowActiveClose()
    })
}

getWindowCMD()

function getWindowCMD() {
    // button navigation
    function getActiveNavBtn() {
        btnCmd.classList.remove(addClassBtnNavPressedNone)
        btnCmd.classList.add(addClassBtnNavFocus)
        btnCmd.classList.add(addClassBtnNavActive)
        classWindowCmd.classList.add(addClassWindowActive)
    }

    // btn navigation
    btnCmd.addEventListener('click', function () {
        getActiveNavBtn()

        if (classWindowCmd.classList.contains(addClassWindowFold)) {
            btnCmd.classList.add(addClassBtnNavFocus)
            btnCmd.classList.remove(addClassBtnNavNoneFocus)
            classWindowCmd.classList.remove(addClassWindowFold)
        }
    })

    // btn apps
    btnCmdApps.addEventListener('click', function () {
        getActiveNavBtn()
    })

    // Fold button
    function getWindowActiveFold() {
        btnCmd.classList.add(addClassBtnNavNoneFocus)
        classWindowCmd.classList.remove(addClassWindowActive)
        classWindowCmd.classList.toggle(addClassWindowFold)
    }

    classBtnWindowCmdFold.addEventListener('click', function () {
        getWindowActiveFold()
    })

    // Expand button
    function getWindowActiveExpand() {
        classWindowCmd.classList.toggle(addClassWindowExpand)

        if (classWindowCmd.classList.contains(addClassWindowExpand)) {
            classWindowCmdIconSvgExpand.style.display = 'none'
            classWindowCmdIconSvgExpandNone.style.display = 'block'
        }

        if (!classWindowCmd.classList.contains(addClassWindowExpand)) {
            classWindowCmdIconSvgExpand.style.display = 'block'
            classWindowCmdIconSvgExpandNone.style.display = 'none'
        }
    }

    classBtnWindowCmdExpand.addEventListener('click', function () {
        getWindowActiveExpand()
    })

    // Double click window panel top
    classWindowCmdTop.addEventListener('click', function (event) {
        let currentTime = new Date().getTime()

        // Проверяем, прошло ли достаточно времени для определения двойного щелчка
        if (currentTime - lastClickTime < doubleClickDelay) {
            getWindowActiveExpand()
        }

        lastClickTime = currentTime
    })

    // Close button

    function getWindowActiveClose() {
        btnCmd.classList.remove(addClassBtnNavFocus)
        btnCmd.classList.remove(addClassBtnNavActive)
        btnCmd.classList.remove(addClassBtnNavNoneFocus)
        classWindowCmd.classList.remove(addClassWindowActive)
        
        btnCmd.classList.add(addClassBtnNavPressedNone)
    }

    classBtnWindowCmdClose.addEventListener('click', function () {
        getWindowActiveClose()
    })
}

getWindowCalculator()

function getWindowCalculator() {
    // button navigation
    function getActiveNavBtn() {
        btnCalculator.classList.remove(addClassBtnNavPressedNone)
        btnCalculator.classList.add(addClassBtnNavFocus)
        btnCalculator.classList.add(addClassBtnNavActive)
        classWindowCalculator.classList.add(addClassWindowActive)
    }

    // btn navigation
    btnCalculator.addEventListener('click', function () {
        getActiveNavBtn()

        if (classWindowCalculator.classList.contains(addClassWindowFold)) {
            btnCalculator.classList.add(addClassBtnNavFocus)
            btnCalculator.classList.remove(addClassBtnNavNoneFocus)
            classWindowCalculator.classList.remove(addClassWindowFold)
        }
    })

    // btn apps
    btnCalculatorApps.addEventListener('click', function () {
        getActiveNavBtn()
    })

    // Fold button
    function getWindowActiveFold() {
        btnCalculator.classList.add(addClassBtnNavNoneFocus)
        classWindowCalculator.classList.remove(addClassWindowActive)
        classWindowCalculator.classList.toggle(addClassWindowFold)
    }

    classBtnWindowCalculatorFold.addEventListener('click', function () {
        getWindowActiveFold()
    })

    // Expand button
    function getWindowActiveExpand() {
        classWindowCalculator.classList.toggle(addClassWindowExpand)

        if (classWindowCalculator.classList.contains(addClassWindowExpand)) {
            classWindowCalculatorIconSvgExpand.style.display = 'none'
            classWindowCalculatorIconSvgExpandNone.style.display = 'block'
        }

        if (!classWindowCalculator.classList.contains(addClassWindowExpand)) {
            classWindowCalculatorIconSvgExpand.style.display = 'block'
            classWindowCalculatorIconSvgExpandNone.style.display = 'none'
        }
    }

    classBtnWindowCalculatorExpand.addEventListener('click', function () {
        getWindowActiveExpand()
    })

    // Double click window panel top
    classWindowCalculatorTop.addEventListener('click', function (event) {
        let currentTime = new Date().getTime()

        // Проверяем, прошло ли достаточно времени для определения двойного щелчка
        if (currentTime - lastClickTime < doubleClickDelay) {
            getWindowActiveExpand()
        }

        lastClickTime = currentTime
    })

    // Close button
    function getWindowActiveClose() {
        btnCalculator.classList.remove(addClassBtnNavFocus)
        btnCalculator.classList.remove(addClassBtnNavActive)
        btnCalculator.classList.remove(addClassBtnNavNoneFocus)
        classWindowCalculator.classList.remove(addClassWindowActive)
        
        btnCalculator.classList.add(addClassBtnNavPressedNone)
    }

    classBtnWindowCalculatorClose.addEventListener('click', function () {
        getWindowActiveClose()
    })
}

getCloseCalculatorHistory()

function getCloseCalculatorHistory() {
    let classWindowCalculator = document.querySelector('.window-calculator')

    classCalculatorHistory.classList.toggle(addClassActiveCalcCloseHistory)
    btnCloseCalculator.classList.toggle(addClassCActiveClose)
    classWindowCalculator.classList.toggle(addClassActiveWidthWindowCalculator)

    btnCloseCalculator.addEventListener('click', function () {
        classCalculatorHistory.classList.toggle(addClassActiveCalcCloseHistory)
        btnCloseCalculator.classList.toggle(addClassCActiveClose)
        classWindowCalculator.classList.toggle(
            addClassActiveWidthWindowCalculator
        )
    })
}

getWindowNotepad()

function getWindowNotepad() {
    // button navigation
    function getActiveNavBtn() {
        btnNotepad.classList.remove(addClassBtnNavPressedNone)
        btnNotepad.classList.add(addClassBtnNavFocus)
        btnNotepad.classList.add(addClassBtnNavActive)
        classWindowNotepad.classList.add(addClassWindowActive)
    }

    // btn navigation
    btnNotepad.addEventListener('click', function () {
        getActiveNavBtn()

        if (classWindowNotepad.classList.contains(addClassWindowFold)) {
            btnNotepad.classList.add(addClassBtnNavFocus)
            btnNotepad.classList.remove(addClassBtnNavNoneFocus)
            classWindowNotepad.classList.remove(addClassWindowFold)
        }
    })

    // btn apps
    btnNotepadApps.addEventListener('click', function () {
        getActiveNavBtn()
    })

    // Fold button
    function getWindowActiveFold() {
        btnNotepad.classList.add(addClassBtnNavNoneFocus)
        classWindowNotepad.classList.remove(addClassWindowActive)
        classWindowNotepad.classList.toggle(addClassWindowFold)
    }

    classBtnWindowNotepadFold.addEventListener('click', function () {
        getWindowActiveFold()
    })

    // Expand button
    function getWindowActiveExpand() {
        classWindowNotepad.classList.toggle(addClassWindowExpand)

        if (classWindowNotepad.classList.contains(addClassWindowExpand)) {
            classWindowNotepadIconSvgExpand.style.display = 'none'
            classWindowNotepadIconSvgExpandNone.style.display = 'block'
        }

        if (!classWindowNotepad.classList.contains(addClassWindowExpand)) {
            classWindowNotepadIconSvgExpand.style.display = 'block'
            classWindowNotepadIconSvgExpandNone.style.display = 'none'
        }
    }

    classBtnWindowNotepadExpand.addEventListener('click', function () {
        getWindowActiveExpand()
    })

    // Double click window panel top
    classWindowNotepadTop.addEventListener('click', function (event) {
        let currentTime = new Date().getTime()

        // Проверяем, прошло ли достаточно времени для определения двойного щелчка
        if (currentTime - lastClickTime < doubleClickDelay) {
            getWindowActiveExpand()
        }

        lastClickTime = currentTime
    })

    // Close button
    function getWindowActiveClose() {
        btnNotepad.classList.remove(addClassBtnNavFocus)
        btnNotepad.classList.remove(addClassBtnNavActive)
        btnNotepad.classList.remove(addClassBtnNavNoneFocus)
        classWindowNotepad.classList.remove(addClassWindowActive)
        
        btnNotepad.classList.add(addClassBtnNavPressedNone)
    }

    classBtnWindowNotepadClose.addEventListener('click', function () {
        getWindowActiveClose()
    })
}

getWindowInfo()

function getWindowInfo() {
    // button navigation
    function getActiveNavBtn() {
        btnInfo.classList.remove(addClassBtnNavPressedNone)
        btnInfo.classList.add(addClassBtnNavFocus)
        btnInfo.classList.add(addClassBtnNavActive)
        classWindowInfo.classList.add(addClassWindowActive)
    }

    // btn navigation
    btnInfo.addEventListener('click', function () {
        getActiveNavBtn()

        if (classWindowInfo.classList.contains(addClassWindowFold)) {
            btnInfo.classList.add(addClassBtnNavFocus)
            btnInfo.classList.remove(addClassBtnNavNoneFocus)
            classWindowInfo.classList.remove(addClassWindowFold)
        }
    })

    // btn desktop
    btnInfoDesktop.addEventListener('click', function (event) {
        let currentTime = new Date().getTime()

        // Проверяем, прошло ли достаточно времени для определения двойного щелчка
        if (currentTime - lastClickTime < doubleClickDelay) {
            getActiveNavBtn()
        }

        lastClickTime = currentTime
    })

    // btn apps
    btnInfoApps.addEventListener('click', function () {
        getActiveNavBtn()
    })

    // Fold button
    function getWindowActiveFold() {
        btnInfo.classList.add(addClassBtnNavNoneFocus)
        classWindowInfo.classList.remove(addClassWindowActive)
        classWindowInfo.classList.toggle(addClassWindowFold)
    }

    classBtnWindowInfoFold.addEventListener('click', function () {
        getWindowActiveFold()
    })

    // Expand button
    function getWindowActiveExpand() {
        classWindowInfo.classList.toggle(addClassWindowExpand)

        if (classWindowInfo.classList.contains(addClassWindowExpand)) {
            classWindowInfoIconSvgExpand.style.display = 'none'
            classWindowInfoIconSvgExpandNone.style.display = 'block'
        }

        if (!classWindowInfo.classList.contains(addClassWindowExpand)) {
            classWindowInfoIconSvgExpand.style.display = 'block'
            classWindowInfoIconSvgExpandNone.style.display = 'none'
        }
    }

    classBtnWindowInfoExpand.addEventListener('click', function () {
        getWindowActiveExpand()
    })

    // Double click window panel top
    classWindowInfoTop.addEventListener('click', function (event) {
        let currentTime = new Date().getTime()

        // Проверяем, прошло ли достаточно времени для определения двойного щелчка
        if (currentTime - lastClickTime < doubleClickDelay) {
            getWindowActiveExpand()
        }

        lastClickTime = currentTime
    })

    // Close button
    function getWindowActiveClose() {
        btnInfo.classList.remove(addClassBtnNavFocus)
        btnInfo.classList.remove(addClassBtnNavActive)
        btnInfo.classList.remove(addClassBtnNavNoneFocus)
        classWindowInfo.classList.remove(addClassWindowActive)
        
        btnInfo.classList.add(addClassBtnNavPressedNone)
    }

    classBtnWindowInfoClose.addEventListener('click', function () {
        getWindowActiveClose()
    })
}

getWindowWeather()

function getWindowWeather() {
    // button navigation
    function getNavBtnActive() {
        classWindowWeather.classList.toggle(addClassWindowActive)
        btnWeather.classList.toggle(addClassBtnWeatherActive)

        if (classWindowWeather.classList.contains(addClassWindowActive)) {
            idAudioSound.play()
        } else if (
            !classWindowWeather.classList.contains(addClassWindowActive)
        ) {
            idAudioSound.pause()
        }
    }

    btnWeather.addEventListener('click', function () {
        getNavBtnActive()
    })

    // button widget workspace
    btnWeatherDesktop.addEventListener('click', function () {
        getNavBtnActive()
    })

    // Expand button
    function getWindowActiveExpand() {
        classWindowWeather.classList.toggle(addClassWindowExpand)

        if (classWindowWeather.classList.contains(addClassWindowExpand)) {
            classWindowWeatherIconSvgExpand.style.display = 'none'
            classWindowWeatherIconSvgExpandNone.style.display = 'block'
        }

        if (!classWindowWeather.classList.contains(addClassWindowExpand)) {
            classWindowWeatherIconSvgExpand.style.display = 'block'
            classWindowWeatherIconSvgExpandNone.style.display = 'none'
        }
    }

    classBtnWindowWeatherExpand.addEventListener('click', function () {
        getWindowActiveExpand()
    })

    // Double click window panel top
    classWindowWeatherTop.addEventListener('click', function (event) {
        let currentTime = new Date().getTime()

        // Проверяем, прошло ли достаточно времени для определения двойного щелчка
        if (currentTime - lastClickTime < doubleClickDelay) {
            getWindowActiveExpand()
        }

        lastClickTime = currentTime
    })

    // Close button
    function getWindowActiveClose() {
        classWindowWeather.classList.remove(addClassWindowActive)
        btnWeather.classList.remove(addClassBtnWeatherActive)
        idAudioSound.pause()
    }

    classBtnWindowWeatherClose.addEventListener('click', function () {
        getWindowActiveClose()
    })
}

getApps()

function getApps() {
    function getActiveApps() {
        classApps.classList.toggle(addClassActiveApps)
        btnApps.classList.toggle(addClassActiveBtn)
    }

    function getRemoveApps() {
        classApps.classList.remove(addClassActiveApps)
        btnApps.classList.remove(addClassActiveBtn)
    }

    btnApps.addEventListener('click', function () {
        getActiveApps()
    })

    document.addEventListener('keydown', function (e) {
        if (e.keyCode == 27) {
            getRemoveApps()
        }
    })

    document
        .querySelector('.apps-slider')
        .addEventListener('click', function () {
            getRemoveApps()
        })

    btnMusic.addEventListener('click', function () {
        getRemoveApps()
    })

    btnWifi2.addEventListener('click', function () {
        getRemoveApps()
    })

    btnVolume2.addEventListener('click', function () {
        getRemoveApps()
    })

    btnNavigation.addEventListener('click', function () {
        getRemoveApps()
    })

    classNavigationInfo.addEventListener('click', function () {
        getRemoveApps()
    })
}

getWifiModal()

function getWifiModal() {
    function getAddClassActiveModalWifi() {
        classWifi.classList.toggle(addClassActiveModal)
    }

    function getRemoveClassActiveModalWifi() {
        classWifi.classList.remove(addClassActiveModal)
    }

    btnWifi.addEventListener('click', function () {
        getAddClassActiveModalWifi()
    })

    document.addEventListener('keydown', function (e) {
        if (e.keyCode == 27) {
            getRemoveClassActiveModalWifi()
        }
    })

    classBackgrounds.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    btnVolume.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    function getAddClassActiveWifiItems() {
        classItemsWifi.classList.toggle(addClasToggleWifiItems)
        classBtnSvgWifiOff2.classList.toggle(addClassActiveBtnSvgWifi2)
        classBtnSvgWifi2.classList.toggle(addClassNoneActiveBtnSvgWifi2)
    }

    btnCheckboxWifi.addEventListener('click', function () {
        getAddClassActiveWifiItems()
    })
}

getWifiModal2()

function getWifiModal2() {
    function getAddClassActiveModalWifi() {
        classWifi2.classList.toggle(addClassActiveModal)
        btnWifi2.classList.toggle(addClassActiveBtn)
    }

    function getRemoveClassActiveModalWifi() {
        classWifi2.classList.remove(addClassActiveModal)
        btnWifi2.classList.remove(addClassActiveBtn)
    }

    btnWifi2.addEventListener('click', function () {
        getAddClassActiveModalWifi()
    })

    document.addEventListener('keydown', function (e) {
        if (e.keyCode == 27) {
            getRemoveClassActiveModalWifi()
        }
    })

    classWindowMove.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    classBackgrounds.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    btnMusic.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    btnNavigation.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    classNavigationInfo.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    btnApps.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    btnVolume2.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    function getAddClassActiveWifiItems() {
        classItemsWifi2.classList.toggle(addClasToggleWifiItems)
        classBtnSvgWifiOff.classList.toggle(addClassActiveBtnSvgWifi)
        classBtnSvgWifi.classList.toggle(addClassNoneActiveBtnSvgWifi)
    }

    btnCheckboxWifi2.addEventListener('click', function () {
        getAddClassActiveWifiItems()
    })
}

getModalValueMod()

function getModalValueMod() {
    function getAddClassActiveModalWifi() {
        classModalVolume.classList.toggle(addClassActiveModal)
    }

    function getRemoveClassActiveModalWifi() {
        classModalVolume.classList.remove(addClassActiveModal)
    }

    btnVolume.addEventListener('click', function () {
        getAddClassActiveModalWifi()
    })

    document.addEventListener('keydown', function (e) {
        if (e.keyCode == 27) {
            getRemoveClassActiveModalWifi()
        }
    })

    classBackgrounds.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    btnWifi.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })
}

getModalValueMod2()

function getModalValueMod2() {
    function getAddClassActiveModalWifi() {
        classModalVolume2.classList.toggle(addClassActiveModal)
        btnVolume2.classList.toggle(addClassActiveBtn)
    }

    function getRemoveClassActiveModalWifi() {
        classModalVolume2.classList.remove(addClassActiveModal)
        btnVolume2.classList.remove(addClassActiveBtn)
    }

    btnVolume2.addEventListener('click', function () {
        getAddClassActiveModalWifi()
    })

    document.addEventListener('keydown', function (e) {
        if (e.keyCode == 27) {
            getRemoveClassActiveModalWifi()
        }
    })

    classWindowMove.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    classBackgrounds.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    btnMusic.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    btnNavigation.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    classNavigationInfo.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    btnWifi2.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    btnApps.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })
}

getMusicModal()

function getMusicModal() {
    function getAddClassActiveModalWifi() {
        classMusicModal.classList.toggle(addClassActiveModalMusic)
        btnMusic.classList.toggle(addClassActiveBtn)
    }

    function getRemoveClassActiveModalWifi() {
        classMusicModal.classList.remove(addClassActiveModalMusic)
        btnMusic.classList.remove(addClassActiveBtn)
    }

    btnMusic.addEventListener('click', function () {
        getAddClassActiveModalWifi()
    })

    document.addEventListener('keydown', function (e) {
        if (e.keyCode == 27) {
            getRemoveClassActiveModalWifi()
        }
    })

    classWindowMove.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    classBackgrounds.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    btnVolume2.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    btnNavigation.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    classNavigationInfo.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    btnWifi2.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    btnApps.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })
}

getMusicPlaylist()

function getMusicPlaylist() {
    function getAddClassActiveMusicPlaylist() {
        classModalMusicPlaylist.classList.add(addClassActiveMusicPlaylist)
        classMusicInner.classList.add(addClassVisibleNone)
    }

    function getRemoveClassActiveMusicPlaylist() {
        classModalMusicPlaylist.classList.remove(addClassActiveMusicPlaylist)
        classMusicInner.classList.remove(addClassVisibleNone)
    }

    btnMusicPlaylist.addEventListener('click', function () {
        getAddClassActiveMusicPlaylist()
    })

    btnMusicPlaylistItem.addEventListener('click', function () {
        getRemoveClassActiveMusicPlaylist()
    })

    document.addEventListener('keydown', function (e) {
        if (e.keyCode == 27) {
            getRemoveClassActiveMusicPlaylist()
        }
    })

    classWindowMove.addEventListener('click', function () {
        getRemoveClassActiveMusicPlaylist()
    })

    classBackgrounds.addEventListener('click', function () {
        getRemoveClassActiveMusicPlaylist()
    })

    btnMusic.addEventListener('click', function () {
        getRemoveClassActiveMusicPlaylist()
    })

    btnNavigation.addEventListener('click', function () {
        getRemoveClassActiveMusicPlaylist()
    })

    classNavigationInfo.addEventListener('click', function () {
        getRemoveClassActiveMusicPlaylist()
    })

    btnWifi2.addEventListener('click', function () {
        getRemoveClassActiveMusicPlaylist()
    })

    btnVolume2.addEventListener('click', function () {
        getRemoveClassActiveMusicPlaylist()
    })

    btnApps.addEventListener('click', function () {
        getRemoveClassActiveMusicPlaylist()
    })
}

getPlayerMusic()

function getPlayerMusic() {
    document.addEventListener('DOMContentLoaded', (e) => {
        let av = document.getElementById('av-tag')
        let playTime = document.getElementsByClassName('play-time')[0]
        let playBtn = document.getElementsByClassName('play-btn')[0]
        let curTime = document.getElementById('cur-time')
        let volume = document.getElementById('volume')
        let speaker = document.getElementById('speaker')

        let isPlaying = false

        av.onloadedmetadata = function () {
            curTime.max = av.duration
        }

        av.ontimeupdate = function () {
            var sec_num = av.currentTime
            var hours = Math.floor(sec_num / 3600)
            var minutes = Math.floor((sec_num - hours * 3600) / 60)
            var seconds = sec_num - hours * 3600 - minutes * 60
            seconds = Math.round(seconds)

            if (hours < 10) {
                hours = '0' + hours
            }
            if (minutes < 10) {
                minutes = '0' + minutes
            }
            if (seconds < 10) {
                seconds = '0' + seconds
            }
            playTime.innerHTML = minutes + ':' + seconds
            if (isPlaying) curTime.value = av.currentTime
        }

        volume.onchange = function () {
            av.volume = volume.value / 10
        }

        curTime.onchange = function () {
            av.pause()
            av.currentTime = curTime.value
            av.play()
        }

        speaker.onclick = function () {
            if (volume.value == 0) {
                volume.value = 10
                av.volume = 1
            } else {
                volume.value = 0
                av.volume = 0
            }
        }

        playBtn.addEventListener('click', (a) => {
            if (isPlaying) {
                av.pause()
                isPlaying = false
                playBtn.innerHTML =
                    '<svg><use xlink:href="img/sprite.svg#icon-play"></use></svg>'
            } else {
                av.play()
                isPlaying = true
                playBtn.innerHTML =
                    '<svg><use xlink:href="img/sprite.svg#icon-pause"></use></svg>'
            }
        })
    })
}

getPluginsActive()

function getPluginsActive() {
    noUiSlider.create(slider, {
        start: 90,
        connect: [true, false],
        range: {
            min: 0,
            max: 100,
        },
    })

    noUiSlider.create(slider2, {
        start: 36,
        connect: [true, false],
        range: {
            min: 0,
            max: 100,
        },
    })

    noUiSlider.create(slider3, {
        start: 90,
        connect: [true, false],
        range: {
            min: 0,
            max: 100,
        },
    })

    noUiSlider.create(slider4, {
        start: 36,
        connect: [true, false],
        range: {
            min: 0,
            max: 100,
        },
    })
}

getDesktopApp()

function getDesktopApp() {
    btnAddTable.addEventListener('click', function () {
        classFileTable.classList.add(addClassActiveFile)
    })

    btnAddDoc.addEventListener('click', function () {
        classFileDoc.classList.add(addClassActiveFile)
    })

    btnAddSlides.addEventListener('click', function () {
        bclassFileSlides.classList.add(addClassActiveFile)
    })
}

getRainAymen()

function getRainAymen() {
    /* credits to https://codepen.io/Nvagelis/pen/yaQGrL */
    /* Check my github :D : https://github.com/aymks */

    window.addEventListener('resize', function () {
        w = canvas1.width = canvas2.width = canvas3.width = window.innerWidth
        h =
            canvas1.height =
            canvas2.height =
            canvas3.height =
                window.innerHeight
    })

    function random(min, max) {
        return Math.random() * (max - min + 1) + min
    }

    function clearcanvas1() {
        ctx1.clearRect(0, 0, w, h)
    }

    function clearcanvas2() {
        ctx2.clearRect(0, 0, canvas2.width, canvas2.height)
    }

    function clearCanvas3() {
        ctx3.globalCompositeOperation = 'destination-out'
        ctx3.fillStyle = 'rgba(0,0,0,' + random(1, 30) / 100 + ')'
        ctx3.fillRect(0, 0, w, h)
        ctx3.globalCompositeOperation = 'source-over'
    }

    function createRainTrough() {
        for (var i = 0; i < rainthroughnum; i++) {
            RainTrough[i] = {
                x: random(0, w),
                y: random(0, h),
                length: Math.floor(random(1, 830)),
                opacity: Math.random() * 0.2,
                xs: random(-2, 2),
                ys: random(10, 20),
            }
        }
    }

    function createRain() {
        for (var i = 0; i < rainnum; i++) {
            rain[i] = {
                x: Math.random() * w,
                y: Math.random() * h,
                l: Math.random() * 1,
                xs: -4 + Math.random() * 4 + 2,
                ys: Math.random() * 10 + 10,
            }
        }
    }

    function createLightning() {
        var x = random(100, w - 100)
        var y = random(0, h / 4)

        var createCount = random(1, 3)
        for (var i = 0; i < createCount; i++) {
            single = {
                x: x,
                y: y,
                xRange: random(5, 30),
                yRange: random(10, 25),
                path: [
                    {
                        x: x,
                        y: y,
                    },
                ],
                pathLimit: random(40, 55),
            }
            lightning.push(single)
        }
    }

    function drawRainTrough(i) {
        ctx1.beginPath()
        var grd = ctx1.createLinearGradient(
            0,
            RainTrough[i].y,
            0,
            RainTrough[i].y + RainTrough[i].length
        )
        grd.addColorStop(0, 'rgba(255,255,255,0)')
        grd.addColorStop(1, 'rgba(255,255,255,' + RainTrough[i].opacity + ')')

        ctx1.fillStyle = grd
        ctx1.fillRect(RainTrough[i].x, RainTrough[i].y, 1, RainTrough[i].length)
        ctx1.fill()
    }

    function drawRain(i) {
        ctx2.beginPath()
        ctx2.moveTo(rain[i].x, rain[i].y)
        ctx2.lineTo(
            rain[i].x + rain[i].l * rain[i].xs,
            rain[i].y + rain[i].l * rain[i].ys
        )
        ctx2.strokeStyle = 'rgba(174,194,224,0.5)'
        ctx2.lineWidth = 1
        ctx2.lineCap = 'round'
        ctx2.stroke()
    }

    function drawLightning() {
        for (var i = 0; i < lightning.length; i++) {
            var light = lightning[i]

            light.path.push({
                x:
                    light.path[light.path.length - 1].x +
                    (random(0, light.xRange) - light.xRange / 2),
                y:
                    light.path[light.path.length - 1].y +
                    random(0, light.yRange),
            })

            if (light.path.length > light.pathLimit) {
                lightning.splice(i, 1)
            }

            ctx3.strokeStyle = 'rgba(255, 255, 255, .1)'
            ctx3.lineWidth = 3
            if (random(0, 15) === 0) {
                ctx3.lineWidth = 6
            }
            if (random(0, 30) === 0) {
                ctx3.lineWidth = 8
            }

            ctx3.beginPath()
            ctx3.moveTo(light.x, light.y)
            for (var pc = 0; pc < light.path.length; pc++) {
                ctx3.lineTo(light.path[pc].x, light.path[pc].y)
            }
            if (Math.floor(random(0, 30)) === 1) {
                //to fos apo piso
                ctx3.fillStyle =
                    'rgba(255, 255, 255, ' + random(1, 3) / 100 + ')'
                ctx3.fillRect(0, 0, w, h)
            }
            ctx3.lineJoin = 'miter'
            ctx3.stroke()
        }
    }

    function animateRainTrough() {
        clearcanvas1()
        for (var i = 0; i < rainthroughnum; i++) {
            if (RainTrough[i].y >= h) {
                RainTrough[i].y = h - RainTrough[i].y - RainTrough[i].length * 5
            } else {
                RainTrough[i].y += speedRainTrough
            }
            drawRainTrough(i)
        }
    }

    function animateRain() {
        clearcanvas2()
        for (var i = 0; i < rainnum; i++) {
            rain[i].x += rain[i].xs
            rain[i].y += rain[i].ys
            if (rain[i].x > w || rain[i].y > h) {
                rain[i].x = Math.random() * w
                rain[i].y = -20
            }
            drawRain(i)
        }
    }

    function animateLightning() {
        clearCanvas3()
        lightTimeCurrent++
        if (lightTimeCurrent >= lightTimeTotal) {
            createLightning()
            lightTimeCurrent = 0
            lightTimeTotal = 200 //rand(100, 200)
        }
        drawLightning()
    }

    function init() {
        createRainTrough()
        createRain()
        window.addEventListener('resize', createRainTrough)
    }
    init()

    function animloop() {
        animateRainTrough()
        animateRain()
        animateLightning()
        requestAnimationFrame(animloop)
    }
    animloop()
}

// Выделение объектов
getAreaSelection()

function getAreaSelection() {
    document.addEventListener('mousedown', (event) => {
        if (event.target.classList.contains('area-selection')) {
            startX = event.clientX
            startY = event.clientY

            selectionRectangle = document.createElement('div')
            selectionRectangle.className = 'selection-rectangle'
            selectionRectangle.style.left = startX + 'px'
            selectionRectangle.style.top = startY + 'px'
            document.body.appendChild(selectionRectangle)
        }
    })

    document.addEventListener('mousemove', (event) => {
        if (selectionRectangle) {
            endX = event.clientX
            endY = event.clientY

            let width = Math.abs(endX - startX)
            let height = Math.abs(endY - startY)
            let left = Math.min(startX, endX)
            let top = Math.min(startY, endY)

            selectionRectangle.style.width = width + 'px'
            selectionRectangle.style.height = height + 'px'
            selectionRectangle.style.left = left + 'px'
            selectionRectangle.style.top = top + 'px'

            let selectedElements = document.querySelectorAll(
                '.block-folder, .block-table, .block-doc, .block-slides, .block-info, .block-donate'
            )
            selectedElements.forEach((element) => {
                let elementRect = element.getBoundingClientRect()
                if (
                    elementRect.left < left + width &&
                    elementRect.left + elementRect.width > left &&
                    elementRect.top < top + height &&
                    elementRect.top + elementRect.height > top
                ) {
                    element.classList.add('block-area-active')
                } else {
                    element.classList.remove('block-area-active')
                }
            })
        }
    })

    document.addEventListener('mouseup', (event) => {
        if (selectionRectangle) {
            document.body.removeChild(selectionRectangle)
            selectionRectangle = null
        }
    })
}

getBlockAreaFolder()

function getBlockAreaFolder() {
    let isDragging = false
    let offset = { x: 0, y: 0 }

    blockFolder.addEventListener('mousedown', (e) => {
        if (e.button === 0) {
            // left mouse button
            isDragging = true
            offset.x = e.pageX - blockFolder.offsetLeft
            offset.y = e.pageY - blockFolder.offsetTop
        }
    })

    document.addEventListener('mouseup', (e) => {
        if (e.button === 0) {
            // left mouse button
            isDragging = false
        }
    })

    document.addEventListener('mousemove', (e) => {
        if (isDragging) {
            const maxX = window.innerWidth - blockFolder.offsetWidth
            const maxY = window.innerHeight - blockFolder.offsetHeight
            let x = e.pageX - offset.x
            let y = e.pageY - offset.y
            x = Math.max(0, Math.min(x, maxX))
            y = Math.max(0, Math.min(y, maxY))
            blockFolder.style.left = x + 'px'
            blockFolder.style.top = y + 'px'
        }
    })
}

getBlockAreaTable()

function getBlockAreaTable() {
    let isDragging = false
    let offset = { x: 0, y: 0 }

    blockTable.addEventListener('mousedown', (e) => {
        if (e.button === 0) {
            // left mouse button
            isDragging = true
            offset.x = e.pageX - blockTable.offsetLeft
            offset.y = e.pageY - blockTable.offsetTop
        }
    })

    document.addEventListener('mouseup', (e) => {
        if (e.button === 0) {
            // left mouse button
            isDragging = false
        }
    })

    document.addEventListener('mousemove', (e) => {
        if (isDragging) {
            const maxX = window.innerWidth - blockTable.offsetWidth
            const maxY = window.innerHeight - blockTable.offsetHeight
            let x = e.pageX - offset.x
            let y = e.pageY - offset.y
            x = Math.max(0, Math.min(x, maxX))
            y = Math.max(0, Math.min(y, maxY))
            blockTable.style.left = x + 'px'
            blockTable.style.top = y + 'px'
        }
    })
}

getBlockAreaDoc()

function getBlockAreaDoc() {
    let isDragging = false
    let offset = { x: 0, y: 0 }

    blockDoc.addEventListener('mousedown', (e) => {
        if (e.button === 0) {
            // left mouse button
            isDragging = true
            offset.x = e.pageX - blockDoc.offsetLeft
            offset.y = e.pageY - blockDoc.offsetTop
        }
    })

    document.addEventListener('mouseup', (e) => {
        if (e.button === 0) {
            // left mouse button
            isDragging = false
        }
    })

    document.addEventListener('mousemove', (e) => {
        if (isDragging) {
            const maxX = window.innerWidth - blockDoc.offsetWidth
            const maxY = window.innerHeight - blockDoc.offsetHeight
            let x = e.pageX - offset.x
            let y = e.pageY - offset.y
            x = Math.max(0, Math.min(x, maxX))
            y = Math.max(0, Math.min(y, maxY))
            blockDoc.style.left = x + 'px'
            blockDoc.style.top = y + 'px'
        }
    })
}

getBlockAreaSlides()

function getBlockAreaSlides() {
    let isDragging = false
    let offset = { x: 0, y: 0 }

    blockSlides.addEventListener('mousedown', (e) => {
        if (e.button === 0) {
            // left mouse button
            isDragging = true
            offset.x = e.pageX - blockSlides.offsetLeft
            offset.y = e.pageY - blockSlides.offsetTop
        }
    })

    document.addEventListener('mouseup', (e) => {
        if (e.button === 0) {
            // left mouse button
            isDragging = false
        }
    })

    document.addEventListener('mousemove', (e) => {
        if (isDragging) {
            const maxX = window.innerWidth - blockSlides.offsetWidth
            const maxY = window.innerHeight - blockSlides.offsetHeight
            let x = e.pageX - offset.x
            let y = e.pageY - offset.y
            x = Math.max(0, Math.min(x, maxX))
            y = Math.max(0, Math.min(y, maxY))
            blockSlides.style.left = x + 'px'
            blockSlides.style.top = y + 'px'
        }
    })
}

getBlockAreaInfo()

function getBlockAreaInfo() {
    let isDragging = false
    let offset = { x: 0, y: 0 }

    blockInfo.addEventListener('mousedown', (e) => {
        if (e.button === 0) {
            // left mouse button
            isDragging = true
            offset.x = e.pageX - blockInfo.offsetLeft
            offset.y = e.pageY - blockInfo.offsetTop
        }
    })

    document.addEventListener('mouseup', (e) => {
        if (e.button === 0) {
            // left mouse button
            isDragging = false
        }
    })

    document.addEventListener('mousemove', (e) => {
        if (isDragging) {
            const maxX = window.innerWidth - blockInfo.offsetWidth
            const maxY = window.innerHeight - blockInfo.offsetHeight
            let x = e.pageX - offset.x
            let y = e.pageY - offset.y
            x = Math.max(0, Math.min(x, maxX))
            y = Math.max(0, Math.min(y, maxY))
            blockInfo.style.left = x + 'px'
            blockInfo.style.top = y + 'px'
        }
    })
}

getBlockAreaDonate()

function getBlockAreaDonate() {
    let isDragging = false
    let offset = { x: 0, y: 0 }

    blockDonate.addEventListener('mousedown', (e) => {
        if (e.button === 0) {
            // left mouse button
            isDragging = true
            offset.x = e.pageX - blockDonate.offsetLeft
            offset.y = e.pageY - blockDonate.offsetTop
            // blockDonate.preventDefault();
        }
    })

    document.addEventListener('mouseup', (e) => {
        if (e.button === 0) {
            // left mouse button
            isDragging = false
            blockDonate.style.pointerEvents = 'all'
        }
    })

    document.addEventListener('mousemove', (e) => {
        if (isDragging) {
            const maxX = window.innerWidth - blockDonate.offsetWidth
            const maxY = window.innerHeight - blockDonate.offsetHeight
            let x = e.pageX - offset.x
            let y = e.pageY - offset.y
            x = Math.max(0, Math.min(x, maxX))
            y = Math.max(0, Math.min(y, maxY))
            blockDonate.style.left = x + 'px'
            blockDonate.style.top = y + 'px'
            blockDonate.style.pointerEvents = 'none'
        }
    })
}

getFullScreenWindowBrowser()

function getFullScreenWindowBrowser() {
    btnClickFull.addEventListener('click', () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen()
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen()
            }
        }
    })
}

copyText()

function copyText() {
    let copyText = document.querySelector('.lockpass')

    copyText.select()
    copyText.setSelectionRange(0, 99999) // For mobile devices
    document.execCommand('copy')
}

getNoneHintLockscreen()

function getNoneHintLockscreen() {
    let classLockscreenHint = document.querySelector('.lockscreen__hint')
    let addClassActiveDNone = 'active-lockscreen-hint-none'

    classLockscreenHint.addEventListener('click', function () {
        classLockscreenHint.classList.add(addClassActiveDNone)
    })
}

getModalBattery()

function getModalBattery() {
    function getAddClassActiveModalWifi() {
        classActiveModalBattery.classList.toggle(addClassActiveModalBattery)
        btnBattery.classList.toggle(addClassActiveBtn)
    }

    function getRemoveClassActiveModalWifi() {
        classActiveModalBattery.classList.remove(addClassActiveModalBattery)
        btnBattery.classList.remove(addClassActiveBtn)
    }

    btnBattery.addEventListener('click', function () {
        getAddClassActiveModalWifi()
    })

    document.addEventListener('keydown', function (e) {
        if (e.keyCode == 27) {
            getRemoveClassActiveModalWifi()
        }
    })

    classWindowMove.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    classBackgrounds.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    btnNavigation.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    classNavigationOption.addEventListener('click', function () {
        getRemoveClassActiveModalWifi()
    })

    if (!addClassActiveModalBattery) {
        classNavigationInfo.addEventListener('click', function () {
            getRemoveClassActiveModalWifi()
        })
    }
}

getAddNavigationOptions()

function getAddNavigationOptions() {
    classNavigationOptionInner.classList.toggle(
        addClassActiveNavigationOptionScaleWidth
    )

    classAddNavigationOptions.addEventListener('click', function () {
        classNavigationOptionInner.classList.toggle(
            addClassActiveNavigationOptionScaleWidth
        )
    })
}

getZIndexWindow()

function getZIndexWindow() {
    // folder
    function windowFolder() {
        classWindowFolder.classList.add(addClassWindowZIndex)
        btnFolder.classList.add(addClassBtnNavPressed)
    }
    function removeWindowFolder() {
        classWindowFolder.classList.remove(addClassWindowZIndex)
        btnFolder.classList.remove(addClassBtnNavPressed)
    }

    // browser
    function windowBrowser() {
        classWindowBrowser.classList.add(addClassWindowZIndex)
        btnBrowser.classList.add(addClassBtnNavPressed)
    }
    function removeWindowBrowser() {
        classWindowBrowser.classList.remove(addClassWindowZIndex)
        btnBrowser.classList.remove(addClassBtnNavPressed)
    }

    // cmd
    function windowCMD() {
        classWindowCmd.classList.add(addClassWindowZIndex)
        btnCmd.classList.add(addClassBtnNavPressed)
    }
    function removeWindowCMD() {
        classWindowCmd.classList.remove(addClassWindowZIndex)
        btnCmd.classList.remove(addClassBtnNavPressed)
    }

    // calculator
    function windowCalculator() {
        classWindowCalculator.classList.add(addClassWindowZIndex)
        btnCalculator.classList.add(addClassBtnNavPressed)
    }
    function removeWindowCalculator() {
        classWindowCalculator.classList.remove(addClassWindowZIndex)
        btnCalculator.classList.remove(addClassBtnNavPressed)
    }

    // notepad
    function windowNotepad() {
        classWindowNotepad.classList.add(addClassWindowZIndex)
        btnNotepad.classList.add(addClassBtnNavPressed)
    }
    function removeWindowNotepad() {
        classWindowNotepad.classList.remove(addClassWindowZIndex)
        btnNotepad.classList.remove(addClassBtnNavPressed)
    }

    // info
    function windowInfo() {
        classWindowInfo.classList.add(addClassWindowZIndex)
        btnInfo.classList.add(addClassBtnNavPressed)
    }
    function removeWindowInfo() {
        classWindowInfo.classList.remove(addClassWindowZIndex)
        btnInfo.classList.remove(addClassBtnNavPressed)
    }

    // weather
    function windowWeather() {
        classWindowWeather.classList.add(addClassWindowZIndex)
    }
    function removeWindowWeather() {
        classWindowWeather.classList.remove(addClassWindowZIndex)
    }

    if (!classWindowZIndex) {
        classWindowFolder.addEventListener('click', function () {
            windowFolder()
            removeWindowCMD()
            removeWindowBrowser()
            removeWindowCalculator()
            removeWindowNotepad()
            removeWindowWeather()
            removeWindowInfo()
        })

        btnFolder.addEventListener('click', function () {
            windowFolder()
            removeWindowCMD()
            removeWindowBrowser()
            removeWindowCalculator()
            removeWindowNotepad()
            removeWindowWeather()
            removeWindowInfo()
        })

        btnFolderDesktop.addEventListener('click', function () {
            windowFolder()
            removeWindowCMD()
            removeWindowBrowser()
            removeWindowCalculator()
            removeWindowNotepad()
            removeWindowWeather()
            removeWindowInfo()
        })

        classWindowCmd.addEventListener('click', function () {
            windowCMD()
            removeWindowFolder()
            removeWindowBrowser()
            removeWindowCalculator()
            removeWindowNotepad()
            removeWindowWeather()
            removeWindowInfo()
        })

        btnCmd.addEventListener('click', function () {
            windowCMD()
            removeWindowFolder()
            removeWindowBrowser()
            removeWindowCalculator()
            removeWindowNotepad()
            removeWindowWeather()
            removeWindowInfo()
        })

        btnCmdApps.addEventListener('click', function () {
            windowCMD()
            removeWindowFolder()
            removeWindowBrowser()
            removeWindowCalculator()
            removeWindowNotepad()
            removeWindowWeather()
            removeWindowInfo()
        })

        classWindowBrowser.addEventListener('click', function () {
            windowBrowser()
            removeWindowFolder()
            removeWindowCMD()
            removeWindowCalculator()
            removeWindowNotepad()
            removeWindowWeather()
            removeWindowInfo()
        })

        btnBrowser.addEventListener('click', function () {
            windowBrowser()
            removeWindowFolder()
            removeWindowCMD()
            removeWindowCalculator()
            removeWindowNotepad()
            removeWindowWeather()
            removeWindowInfo()
        })

        btnBrowserApps.addEventListener('click', function () {
            windowBrowser()
            removeWindowFolder()
            removeWindowCMD()
            removeWindowCalculator()
            removeWindowNotepad()
            removeWindowWeather()
            removeWindowInfo()
        })

        classWindowCalculator.addEventListener('click', function () {
            windowCalculator()
            removeWindowFolder()
            removeWindowCMD()
            removeWindowBrowser()
            removeWindowNotepad()
            removeWindowWeather()
            removeWindowInfo()
        })

        btnCalculator.addEventListener('click', function () {
            windowCalculator()
            removeWindowFolder()
            removeWindowCMD()
            removeWindowBrowser()
            removeWindowNotepad()
            removeWindowWeather()
            removeWindowInfo()
        })

        btnCalculatorApps.addEventListener('click', function () {
            windowCalculator()
            removeWindowFolder()
            removeWindowCMD()
            removeWindowBrowser()
            removeWindowNotepad()
            removeWindowWeather()
            removeWindowInfo()
        })

        classWindowNotepad.addEventListener('click', function () {
            windowNotepad()
            removeWindowFolder()
            removeWindowCMD()
            removeWindowBrowser()
            removeWindowCalculator()
            removeWindowWeather()
            removeWindowInfo()
        })

        btnNotepad.addEventListener('click', function () {
            windowNotepad()
            removeWindowFolder()
            removeWindowCMD()
            removeWindowBrowser()
            removeWindowCalculator()
            removeWindowWeather()
            removeWindowInfo()
        })

        btnNotepadApps.addEventListener('click', function () {
            windowNotepad()
            removeWindowFolder()
            removeWindowCMD()
            removeWindowBrowser()
            removeWindowCalculator()
            removeWindowWeather()
            removeWindowInfo()
        })

        classWindowWeather.addEventListener('click', function () {
            windowWeather()
            removeWindowFolder()
            removeWindowCMD()
            removeWindowBrowser()
            removeWindowCalculator()
            removeWindowNotepad()
            removeWindowInfo()
        })

        btnWeather.addEventListener('click', function () {
            windowWeather()
            removeWindowFolder()
            removeWindowCMD()
            removeWindowBrowser()
            removeWindowCalculator()
            removeWindowNotepad()
            removeWindowInfo()
        })

        btnWeatherDesktop.addEventListener('click', function () {
            windowWeather()
            removeWindowFolder()
            removeWindowCMD()
            removeWindowBrowser()
            removeWindowCalculator()
            removeWindowNotepad()
            removeWindowInfo()
        })

        classWindowInfo.addEventListener('click', function () {
            windowInfo()
            removeWindowFolder()
            removeWindowCMD()
            removeWindowBrowser()
            removeWindowCalculator()
            removeWindowNotepad()
            removeWindowWeather()
        })

        btnInfo.addEventListener('click', function () {
            windowInfo()
            removeWindowFolder()
            removeWindowCMD()
            removeWindowBrowser()
            removeWindowCalculator()
            removeWindowNotepad()
            removeWindowWeather()
        })

        btnInfoDesktop.addEventListener('click', function () {
            windowInfo()
            removeWindowFolder()
            removeWindowCMD()
            removeWindowBrowser()
            removeWindowCalculator()
            removeWindowNotepad()
            removeWindowWeather()
        })

        btnInfoApps.addEventListener('click', function () {
            windowInfo()
            removeWindowFolder()
            removeWindowCMD()
            removeWindowBrowser()
            removeWindowCalculator()
            removeWindowNotepad()
            removeWindowWeather()
        })
    }
}

getNavFoldWindows()

function getNavFoldWindows() {
    // folder
    function removeWindowFolder() {
        if (classWindowFolder.classList.contains(addClassWindowActive)) {
            btnFolder.classList.add(addClassBtnNavNoneFocus)
            classWindowFolder.classList.remove(addClassWindowActive)
            classWindowFolder.classList.add(addClassWindowFold)
        } else if (classWindowFolder.classList.contains(addClassWindowFold)) {
            btnFolder.classList.remove(addClassBtnNavNoneFocus)
            btnFolder.classList.add(addClassBtnNavFocus)
            btnFolder.classList.add(addClassBtnNavActive)
            classWindowFolder.classList.add(addClassWindowActive)
        }
    }

    // cmd
    function removeWindowCmd() {
        if (classWindowCmd.classList.contains(addClassWindowActive)) {
            btnCmd.classList.add(addClassBtnNavNoneFocus)
            classWindowCmd.classList.remove(addClassWindowActive)
            classWindowCmd.classList.add(addClassWindowFold)
        } else if (classWindowCmd.classList.contains(addClassWindowFold)) {
            btnCmd.classList.remove(addClassBtnNavNoneFocus)
            btnCmd.classList.add(addClassBtnNavFocus)
            btnCmd.classList.add(addClassBtnNavActive)
            classWindowCmd.classList.add(addClassWindowActive)
        }
    }

    // browser
    function removeWindowBrowser() {
        if (classWindowBrowser.classList.contains(addClassWindowActive)) {
            btnBrowser.classList.add(addClassBtnNavNoneFocus)
            classWindowBrowser.classList.remove(addClassWindowActive)
            classWindowBrowser.classList.add(addClassWindowFold)
        } else if (classWindowBrowser.classList.contains(addClassWindowFold)) {
            btnBrowser.classList.remove(addClassBtnNavNoneFocus)
            btnBrowser.classList.add(addClassBtnNavFocus)
            btnBrowser.classList.add(addClassBtnNavActive)
            classWindowBrowser.classList.add(addClassWindowActive)
        }
    }

    // calculator
    function removeWindowCalculator() {
        if (classWindowCalculator.classList.contains(addClassWindowActive)) {
            btnCalculator.classList.add(addClassBtnNavNoneFocus)
            classWindowCalculator.classList.remove(addClassWindowActive)
            classWindowCalculator.classList.add(addClassWindowFold)
        } else if (
            classWindowCalculator.classList.contains(addClassWindowFold)
        ) {
            btnCalculator.classList.remove(addClassBtnNavNoneFocus)
            btnCalculator.classList.add(addClassBtnNavFocus)
            btnCalculator.classList.add(addClassBtnNavActive)
            classWindowCalculator.classList.add(addClassWindowActive)
        }
    }

    // notepad
    function removeWindowNotepad() {
        if (classWindowNotepad.classList.contains(addClassWindowActive)) {
            btnNotepad.classList.add(addClassBtnNavNoneFocus)
            classWindowNotepad.classList.remove(addClassWindowActive)
            classWindowNotepad.classList.add(addClassWindowFold)
        } else if (classWindowNotepad.classList.contains(addClassWindowFold)) {
            btnNotepad.classList.remove(addClassBtnNavNoneFocus)
            btnNotepad.classList.add(addClassBtnNavFocus)
            btnNotepad.classList.add(addClassBtnNavActive)
            classWindowNotepad.classList.add(addClassWindowActive)
        }
    }

    // info
    function removeWindowInfo() {
        if (classWindowInfo.classList.contains(addClassWindowActive)) {
            btnInfo.classList.add(addClassBtnNavNoneFocus)
            classWindowInfo.classList.remove(addClassWindowActive)
            classWindowInfo.classList.add(addClassWindowFold)
        } else if (classWindowInfo.classList.contains(addClassWindowFold)) {
            btnInfo.classList.remove(addClassBtnNavNoneFocus)
            btnInfo.classList.add(addClassBtnNavFocus)
            btnInfo.classList.add(addClassBtnNavActive)
            classWindowInfo.classList.add(addClassWindowActive)
        }
    }

    // weather
    function removeWindowWeather() {
        if (
            classWindowWeather.classList.contains('window-weather') &&
            classWindowWeather.classList.contains('window-active')
        ) {
            classWindowWeather.classList.remove(addClassWindowActive)
            btnWeather.classList.remove(addClassBtnWeatherActive)
        }
    }

    classNavFoldCollapsAll.addEventListener('click', function () {
        removeWindowFolder()
        removeWindowCmd()
        removeWindowBrowser()
        removeWindowCalculator()
        removeWindowNotepad()
        removeWindowInfo()
        removeWindowWeather()
    })
}

// getWindowActiveBtn();

function getWindowActiveBtn() {
    btn1.addEventListener('click', function () {
        btn1.classList.add(addClassBtnNavFocus)
        btn1.classList.add(addClassBtnNavActive)
        classWindow1.classList.add(addClassWindowActive)

        if (btn2.classList.contains(addClassBtnNavActive)) {
            btn1.classList.remove(addClassBtnNavNoneFocus)
            btn2.classList.add(addClassBtnNavNoneFocus)
        }

        if (classWindow1.classList.contains(addClassWindowFold)) {
            btn1.classList.add(addClassBtnNavFocus)
            btn1.classList.remove(addClassBtnNavNoneFocus)
            classWindow1.classList.remove(addClassWindowFold)
        }
    })

    btn2.addEventListener('click', function () {
        btn2.classList.add(addClassBtnNavFocus)
        btn2.classList.add(addClassBtnNavActive)
        classWindow2.classList.add(addClassWindowActive)

        if (btn1.classList.contains(addClassBtnNavActive)) {
            btn2.classList.remove(addClassBtnNavNoneFocus)
            btn1.classList.add(addClassBtnNavNoneFocus)
        }

        if (classWindow1.classList.contains(addClassBtnWindow2Fold)) {
            btn2.classList.add(addClassBtnNavFocus)
            btn2.classList.remove(addClassBtnNavNoneFocus)
            classWindow1.classList.remove(addClassBtnWindow2Fold)
        }
    })

    classBtnWindow2Fold.addEventListener('click', function () {
        btn2.classList.add(addClassBtnNavNoneFocus)
        classWindow2.classList.remove(addClassWindowActive)
        classWindow2.classList.toggle(addClassBtnWindow1Fold)
    })

    classBtnWindow2Expand.addEventListener('click', function () {
        classWindow2.classList.toggle(addClassWindowExpand)
    })

    classBtnWindow2Close.addEventListener('click', function () {
        btn2.classList.remove(addClassBtnNavFocus)
        btn2.classList.remove(addClassBtnNavActive)
        btn2.classList.remove(addClassBtnNavNoneFocus)
        classWindow2.classList.remove(addClassWindowActive)
    })
}

getAccordionItems()

function getAccordionItems() {
    const accordionItems = document.querySelectorAll('.accordion-item')

    accordionItems.forEach((item) => {
        const header = item.querySelector('.accordion-header')
        const content = item.querySelector('.accordion-content')

        header.addEventListener('click', () => {
            item.classList.toggle('open')
        })
    })
}

getTheme()

function getTheme() {
    // Получаем кнопку и элемент, к которому нужно добавить класс
    const classActiveTheme = 'active-theme'
    const btnTheme = document.querySelector('.btn-theme')
    const bodyElement = document.querySelector('.body')
    const addClassBtnActiveModifi = 'modal-modifi-nav__item_active'

    // Проверяем, есть ли сохраненное состояние класса в localStorage
    if (localStorage.getItem('activeTheme') === 'true') {
        // Если есть, добавляем класс
        bodyElement.classList.add(classActiveTheme)
        btnTheme.classList.add(addClassBtnActiveModifi)
    }

    // Обработчик события при нажатии на кнопку
    btnTheme.addEventListener('click', function () {
        // Проверяем, есть ли класс у элемента
        if (bodyElement.classList.contains(classActiveTheme)) {
            // Если есть, удаляем класс и сохраняем состояние в localStorage
            bodyElement.classList.remove(classActiveTheme)
            btnTheme.classList.remove(addClassBtnActiveModifi)
            localStorage.setItem('activeTheme', 'false')
        } else {
            // Если нет, добавляем класс и сохраняем состояние в localStorage
            bodyElement.classList.add(classActiveTheme)
            btnTheme.classList.add(addClassBtnActiveModifi)
            localStorage.setItem('activeTheme', 'true')
        }
    })
}
